/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MultistreamTarget from "./target.defs.js";
import * as MultistreamDefs from "./defs.defs.js";

const $nsid = "place.stream.multistream.createTarget";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"multistreamTarget":/*#__PURE__*/ l.ref<MultistreamTarget.Main>((() => MultistreamTarget.main) as any)});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.payload("application/json", /*#__PURE__*/ l.ref<MultistreamDefs.TargetView>((() => MultistreamDefs.targetView) as any));

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Create a new target for rebroadcasting a Streamplace stream. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["InvalidTargetUrl"]);

export { main };

export const $lxm = $nsid;
